module.exports = __webpack_public_path__ + "static/media/icon-pembinaan-pegawai.eb787788.png";